<template>
	<div id="advertisement">
		<div class="row clearfix middle-row between" style="height: 100px;width: 100%;margin: 0px;">
			<div class="col-md-3 statu middle-row around" style="margin-right: 5px;background-color:#64b0f2;">
				<h3><i class="fa fa-cogs fa-fw fa-2x"></i></h3>
				<div class="middle-column center">
					<h4>设备总数</h4>
					<span style="font-size: 40px;">{{state.total}}</span>
				</div>
			</div>
			<div class="col-md-3 statu middle-row around" style="margin: 0px 5px;background-color: darkseagreen;">
				<h3>
					<i class="fa fa-eercast fa-fw fa-2x"></i>
				</h3>
				<div class="middle-column center">
					<h4>在线总数</h4> 
					<span style="font-size: 40px;">{{isNaN(state.online+state.warning) ? 0 : (state.online+state.warning)}}</span>
				</div>
			</div>
			<div class="col-md-3 statu middle-row around" style="margin: 0px 5px;background-color: #ff5d48;">
				<h3>
					<i class="fa fa-bell-o fa-fw  fa-2x"></i>
				</h3>
				<div class="middle-column center" style="color: darkred;">
					<h4>报警总数</h4>
					<span style="font-size: 40px;">{{state.warning}}</span>
				</div>
			</div>
			<div class="col-md-3 statu middle-row around" style="margin-left: 5px;background-color: #f1b53d;">
				<h3><i class="fa fa-power-off fa-fw  fa-2x"></i></h3>
				<div class="middle-column center">
					<h4>离线总数</h4>
					<span style="font-size: 40px;">{{state.offline}}</span>
				</div>
			</div>
		</div>
		<div class="clearfix" style="margin-top: 10px;">
			<div class="col-md-3 column" ref='setwidth' style="padding: 0px  5px  0px  0px;">
				<div class="left-nav bg-self" style="border-bottom: 10px solid  #f5f5f5;padding: 0px;">
					<h3 style="padding: 10px 0px;">设备列表 <span class="badge bg-sea">共{{merchants.length}}台设备</span></h3>
					<ul class="list-group text-left" id="equs">
						<li class="list-group-item middle-row between" :id="'mer'+index" v-for="(mer,index) in merchants" :key='index' :class="index==selected?'listactive':''" @click="changeMerchant(index)">
							<div class="middle-row start"  v-if="mer.state=='warning'" >
								<i class="fa fa-circle fa-2x red"></i>&nbsp;&nbsp;&nbsp;<small>{{mer.merchantName}}</small>
							</div>
							<div class="middle-row start"  v-if="mer.state=='online'" >
								<i class="fa fa-circle fa-2x green"></i>&nbsp;&nbsp;&nbsp;<small>{{mer.merchantName}}</small>
							</div>
							<div class="middle-row start"  v-if="mer.state=='offline'" >
								<i class="fa fa-circle fa-2x gray"></i>&nbsp;&nbsp;&nbsp;<small>{{mer.merchantName}}</small>
							</div>
							<div class="middle-row"  v-if="mer.state=='warning'" >
								<button class="btn btn-sm btn-danger"  @click="mainchange" >更多数据</button>
							</div>
							<div class="middle-row"  v-if="mer.state=='online'" >
								<button class="btn btn-sm btn-success"  @click="mainchange">更多数据</button>
							</div>
							<div class="middle-row"  v-if="mer.state=='offline'" >
								<button class="btn btn-sm btn-default"  @click="mainchange">更多数据</button>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="col-md-6 column" style="padding:0px  0px  0px  5px;;">
				<baidu-map class="bm-view" :zoom="zoom" :center="center" ak="OydBLLOIYzqXFEIoDNyBKM5lVuNYhucB"
				 :scroll-wheel-zoom='true' @moveend="getCenter">
					<bm-boundary name="淮北市相山区" :strokeWeight="2" strokeColor="blue"  :fillColor="fillColor" :clicking="clicking"></bm-boundary>
					<i v-for="(mer,i) in merchants" :key='i'>
						<bm-marker :title="mer.merchantName" v-if="selected != i && mer.state !='warning'" @click="scrollIntoView(i)" :position="{lng:mer.longitude,lat:mer.latitude}" :dragging="false" :icon="{url:'/api/nomal.png',size: {width:36, height:46}}">
						</bm-marker>
						<bm-marker :title="mer.merchantName" v-if="selected != i && mer.state=='warning'" @click="scrollIntoView(i)" :position="{lng:mer.longitude,lat:mer.latitude}" :dragging="false" :icon="{url:'/api/warning.png',size: {width:36, height:46}}">
						</bm-marker>
						<bm-marker :title="mer.merchantName" @click="infoWindowOpen" v-if="selected == i&& mer.state!='warning'" :key='i' :position="{lng:mer.longitude,lat:mer.latitude}" :dragging="false" :icon="{url:'/api/active.png',size: {width:25, height:34}}" animation="BMAP_ANIMATION_BOUNCE">
						</bm-marker>
						<bm-marker :title="mer.merchantName" @click="infoWindowOpen" v-if="selected == i&& mer.state=='warning'" :key='i' :position="{lng:mer.longitude,lat:mer.latitude}" :dragging="false"  animation="BMAP_ANIMATION_BOUNCE">
						</bm-marker>
					</i>
				</baidu-map>
			</div>
			<div class="col-md-3 column" style="padding:0px  0px  0px  5px;border: 3px solid white;height:506px;background-color: #f7f7f7;">
				<div style="height: 100%;width: 100%;align-items: flex-start;" class="middle-column start rightinfo">
					<div class="middle-row start" style="width:85%;">
						<div class="input-group" style="margin: 5px">
							<input type="text" class="form-control" placeholder="请输入商户名称或者设备编号" v-model="searchKey" size="30" @keydown.enter="search">
						</div>
						<button class="btn btn-primary" @click="search" data-toggle="modal" data-target="#merchant"><i class="fa fa-search"></i>&nbsp;搜索设备</button>
					</div>
					<span>设备名称:{{merchant.merchantName}}</span>
					<span>设备编号:{{merchant.equNum}}</span>
					<span>设备类型:{{merchant.equType}}</span>
					<span>设备状态:<span v-text="merchant.state=='online'?'运转':'停机'"></span></span>
					<span style="text-align: left;">最新数据上传时间: {{lastdata.time}}</span>
					<span>监测时间间隔:5分钟</span>
				</div>
			</div>
		</div>
		<!--各传感器数据-->
		<div class="row middle-row between wrap" style="height: 90px;width: 100%;margin: 10px 0px;">
			<div class="statu state middle-column center" :style="{backgroundColor:(lastdata.bzs>standard.bzs?'#ff5d48':'')}">
				<span style="font-size: large;">苯系物:<b> {{lastdata.bzs}}</b> ppm</span>
				<span style="font-size: large;">标准值:<b> {{standard.bzs}}</b> ppm <b v-if="lastdata.bzs>standard.bzs">超标!</b><b v-else>达标</b></span>
			</div>
			<div class="statu state middle-column center" :style="{backgroundColor:(lastdata.nmthc>standard.nmthc?'#ff5d48':'')}">
				<span style="font-size: large;">非甲烷总烃:<b> {{lastdata.nmthc}}</b> mg/m³</span>
				<span style="font-size: large;">标准值:<b> {{standard.nmthc}}</b> mg/m³ <b v-if="lastdata.nmthc>standard.nmthc">超标!</b><b v-else>达标</b></span>
			</div>
			<div class="statu state middle-column center" :style="{backgroundColor:(lastdata.pc>standard.pc?'#ff5d48':'')}">
				<span style="font-size: large;">颗粒物浓度:<b> {{lastdata.pc}}</b> mg/m³</span>
				<span style="font-size: large;">标准值:<b> {{standard.pc}}</b> mg/m³ <b v-if="lastdata.pc>standard.pc">超标!</b><b v-else>达标</b></span>
			</div>
			<div class="statu state middle-column center" :style="{backgroundColor:(lastdata.bz>standard.bz?'#ff5d48':'')}">
				<span style="font-size: large;">设备状态:<b v-text="merchant.state=='online'?'正在运行':'设备关机'"></b></span>
			</div>
		</div>
		<div class="row middle-row between wrap" style="height: 90px;width: 100%;margin: 10px 0px;">
			<div class="statu state middle-column center">
				<span style="font-size: large;">温度<b>{{lastdata.temp}}</b> ℃</span>
			</div>
			<div class="statu state middle-column center" >
				<span style="font-size: large;">设备状态:<b v-text="merchant.state=='offline'?' 设备关机':' 正在运行'"></b></span>
			</div>
			<div style="height: 100%;width: 23%;">
			</div>
			<div style="height: 100%;width: 23%;">
			</div>
		</div>
		<div class="modal fade" id="merchant" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content" style="overflow-y: scroll;">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
						<h4 class="modal-title" id="myModalLabel">{{info}}</h4>
					</div>
					<table class="table " v-if="showTable">
						<thead>
							<tr>
								<th>编号</th>
								<th>设备编号</th>
								<th>商户名称</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(mer,n) in searchMerchants" :class="index == n?'active':''" @click="chooseMer(n)"   :key="n">
								<td>{{n+1}}</td>
								<td>{{mer.equNum}}</td>
								<td>{{mer.merchantName}}</td>
							</tr>
						</tbody>
					</table>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
						<button type="button" class="btn btn-primary"  :disabled="!showTable" @click="confirm">选择</button>
					</div>
				</div><!-- /.modal-content -->
			</div><!-- /.modal -->
		</div>
	</div>
</template>

<script>
	import {
		BaiduMap,
		BmMarker,
		BmCircle,BmBoundary
	} from 'vue-baidu-map'
	
	import {util} from '../../static/util.js'
	
	export default {
		name: 'advertisement',
		data() {
			return {
				center: {
					lng: 116.811642,
					lat: 33.970323
				},
				zoom: 14,
				radius: 100,
				width: "0",
				status: 1,
				merchants:[],
				merchant:{},
				selected:0,
				lastdata:{},
				state:{'total':0,'online':0,'offline':0},
				showMapInfo:false,
				fillColor:'',
				clicking:false,
				searchKey:'',
				searchMerchants:[],
				showTable: true, 
				info: '搜索结果',
				index:0,
				searchMer:'',
				standard:''
			}
		},
		methods: {
			confirm:function function_name () {
				for(var i=0;i<this.merchants.length;i++){
					if(this.merchants[i].equNum==this.searchMer.equNum){
						console.log(i);
						this.scrollIntoView(i);
						$("#merchant").modal("hide");
						return;
					}
				}
				alert('未找到指定设备，请确定设备类型是否正确')
			},
			chooseMer:function(n) {
				this.searchMer = this.searchMerchants[n]
				this.index = n;
			},
			search: function() {
				if (!this.searchKey || this.searchKey == '') {
					this.info = '请输入搜索关键字';
					this.showTable = false;
				} else {
					this.$http.post(this.GLOBAL.base + 'searchMerchant', {
						like: this.searchKey
					}, {
						emulateJSON: true
					}).then(function(res) {
						this.searchMerchants = res.body;
						if(!this.searchMerchants){
							this.info = '未查找到相关监控点';
							this.showTable = false;
						}
						this.info = '共搜索出以下结果';
						this.showTable = true;
					})
				}
				return true;
			},
			scrollIntoView:function(i) {
				document.getElementById("mer"+i).scrollIntoView();
				this.changeMerchant(i);
			},
			infoWindowClose:function () {
				this.showMapInfo = false
			},
			infoWindowOpen:function () {
				this.showMapInfo = true;
			},
			getCenter: function(e) {},
			setRadius: function(e) {},
			toDetail:function(e,n) {
				this.$parent.toDetail(e,n);
			},
			getMerchants:function() {
				this.$http.get(this.GLOBAL.base+'getMerchants',{params:{target:'工业企业废气'}}).then(function(res) {
					this.merchants = res.body;
					this.merchant = this.merchants[0];
					this.getLastData();
				})
			},
			changeMerchant:function(index) {
				this.selected = index;
				this.merchant = this.merchants[index];
				this.getLastData();
			},
			getLastData:function () {
				this.$http.get(this.GLOBAL.base+'getLastData',{params:{equId:this.merchant.equNum,type:'carrepair'}}).then(function (res) {
					this.lastdata = res.body;
					this.lastdata.time = util.timeToStringWithMonth(this.lastdata.time);
					util.carRepairFixed(this.lastdata);
				})
			},
			mainchange:function() {
				this.$emit("toDetail",{equId:this.merchant.equNum,merchantName:this.merchant.merchantName,equType:this.merchant.equType})
			},
			countState:function() {
				this.$http.get(this.GLOBAL.base+'countStateByType',{params:{type:'工业企业废气'}}).then(function(msg) {
					this.state = msg.body;
					this.state.warning=0;
				})
			},
			getStandard:function() {
				this.$http.get(this.GLOBAL.base+'getStandard').then(function(res) {
					this.standard = res.body.carRepair;
				});
			}
		},
		components: {
			BaiduMap,
			BmMarker,
			BmCircle,BmBoundary
		},
		mounted() {
			this.getMerchants();
			this.countState();
			this.getStandard();
		}
	}
</script>

<style>
	#advertisement {
		width: 100%;
	}

	.bm-view {
		width: 100%;
		height: 500px;
	}

	.statu {
		height: 100%;
		padding: 0px 10px !important;
	}

	h4 {
		font-weight: bold;
	}

	.BMap_cpyCtrl {
		display: none;
	}

	.anchorBL {
		display: none;
	}

	.right-nav ve-line {
		width: 100%;
	}
</style>
